export default function B2BRegistrationDone() {
    return (
        <div className="b2b-done">
            It's done! You are registered user now :D
        </div>
    )
}